import { MermaidThemeRegistry } from '../themes/MermaidThemeRegistry';
import type { Configuration, Theme } from '../types';
import { getMermaidScript } from './rehype-mermaid.js';

export class StyleApplier {
  private readonly theme: Theme;
  private readonly config: Configuration | undefined;
  private readonly mermaidThemeRegistry: MermaidThemeRegistry;

  constructor(theme: Theme, config?: Configuration) {
    this.theme = theme;
    this.config = config;
    this.mermaidThemeRegistry = new MermaidThemeRegistry();
  }

  async apply(html: string): Promise<string> {
    // TODO: Implement proper CSS injection and processing
    console.log(`StyleApplier: Applying theme '${this.theme.name}' (stub implementation)`);

    // Simple CSS injection for now
    const styles = this.theme.styles.join('\n');

    // Add theme-aware Mermaid resources if enabled
    let mermaidResources = '';
    if (this.config?.features.diagrams?.mermaid) {
      const mermaidCSS = this.mermaidThemeRegistry.generateCSS(this.config.theme);
      mermaidResources = mermaidCSS + getMermaidScript();
      console.log(
        `[StyleApplier] Adding enterprise Mermaid resources for theme: ${this.config.theme}`
      );
    }

    // Insert styles into the HTML document
    if (html.includes('<head>')) {
      return html.replace('<head>', `<head>\n<style>\n${styles}\n</style>${mermaidResources}`);
    } else if (html.includes('<html>')) {
      return html.replace('<html>', `<html>\n<head>\n<style>\n${styles}\n</style>\n</head>`);
    } else {
      // If no proper HTML structure, wrap everything
      return `<!DOCTYPE html>
<html>
<head>
<style>
${styles}
</style>
</head>
<body>
${html}
</body>
</html>`;
    }
  }

  /**
   * Get theme information
   */
  getTheme(): Theme {
    return this.theme;
  }

  /**
   * Get compiled styles
   */
  getStyles(): string {
    return this.theme.styles.join('\n');
  }
}
